import { useEffect } from 'react';

/** /admin/control-room and /admin/links are private front doors that hand off to the
 *  admin-gated Control Room page on the backend. Nothing is rendered or exposed here. */
export default function AdminControlRoomRedirect() {
  useEffect(() => {
    const prev = document.title;
    document.title = 'Payday Relay, Control Room';
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex, nofollow, noarchive');
    window.location.replace('/api/admin/control-room');
    return () => { document.title = prev; };
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center text-sm"
      style={{ background: '#2A1E5C', color: 'rgba(255,255,255,0.75)' }}
      data-testid="admin-control-room-redirect"
    >
      Opening the Control Room…
    </div>
  );
}
